export default "__VITE_ASSET__CAgH0sw3__"